export default __webpack_public_path__ + "static/GT-America-Extended-Regular-fe3fe6719ce2b59b6c153786fd24c2e9.woff";